export const BRAND = "NovasMoney";
export const BRAND_UPPER = "NOVASMONEY";
export const TAGLINE = "Your Money, Growing Faster";
export const SUPPORT_EMAIL = "support@novasmoney.in";
export const PACKAGE_NAME = "com.novasmoney.app";
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const SOCIAL_PROOF_DOWNLOADS = "356K+";

export const NAV_LINKS = [
  { to: "/download", key: "download" },
  { to: "/latest-version", key: "latest" },
  { to: "/about", key: "about" },
  { to: "/support", key: "support" },
];

export const MOBILE_EXTRA_LINKS = [
  { to: "/changelog", key: "changelog" },
  { to: "/contact", key: "contact" },
];

export const HERO_STATS = [
  { value: "₹150Cr+", label: "Volume" },
  { value: "120K+", label: "Users" },
  { value: "3.8s", label: "Payout" },
];

export const MARQUEE = ["Instant Payouts", "Daily Earnings", "Team Rewards", "Bank-Grade Security", "₹150Cr+ Processed", "24/7 Priority Support"];

export const HOME_FAQ = [
  { q: `What is ${BRAND_UPPER}?`, a: `${BRAND_UPPER} is an Indian premium fintech platform offering a wallet, daily earnings, team referral rewards, and instant bank/UPI withdrawals — all denominated in ₹ and built for the way India transacts.` },
  { q: `Where can I download the official ${BRAND_UPPER} APK?`, a: `Only from this official website. Open the Download page and tap "Download ${BRAND_UPPER} APK" — you'll always get the latest signed release served directly from our servers.` },
  { q: `Is the ${BRAND_UPPER} APK safe to install?`, a: `Yes. Every release is signed by the ${BRAND_UPPER} team, and we publish the SHA-256 checksum of each file so you can verify that the APK you downloaded is authentic and untouched.` },
  { q: `What is the latest ${BRAND_UPPER} version?`, a: `The latest version is always shown on the Latest Version page and on the download card above. It updates automatically the moment we publish a new release.` },
  { q: `How do I update ${BRAND_UPPER} on my phone?`, a: `Download the newest APK from this site and install it over your existing app. Your account and wallet data stay intact. If a release is marked "Force Update", the app will ask you to update before continuing.` },
  { q: "Where can I get help?", a: `Visit the Support page or email ${SUPPORT_EMAIL}. Our team responds within 24 hours.` },
];

export const DOWNLOAD_FAQ = [
  { q: "How do I install an APK on Android?", a: "After downloading, open the file from your notifications or Downloads folder. If prompted, allow \"Install unknown apps\" for your browser, then tap Install." },
  { q: "Which Android versions are supported?", a: "The minimum supported Android version is shown on the download card for every release. Most releases support Android 7.0 and above." },
  { q: "Can I install it on iPhone?", a: `${BRAND_UPPER} is currently available as an Android APK only. Use the QR code to send the download link to an Android phone.` },
  { q: "How can I verify the download?", a: "Compare the SHA-256 checksum shown on this page with the checksum of the downloaded file (for example, using a file hash app). They must match exactly." },
];

export const SUPPORT_FAQ = [
  { q: "I can't install the APK. What should I do?", a: "Make sure \"Install unknown apps\" is enabled for your browser, that you have enough free storage, and that you downloaded the latest version from this site." },
  { q: "My withdrawal is pending. Who do I contact?", a: `Email ${SUPPORT_EMAIL} with your registered mobile number and transaction ID. We respond within 24 hours.` },
  { q: "Is there an iOS app?", a: `Not yet. ${BRAND_UPPER} is available on Android via the official APK.` },
];
